import React from "react";
import PropTypes from "prop-types";

const Message = props => {
  const { type, children } = props;

  return (
    <div className={`dashboard-message dashboard-message--${type}`}>
      {children}
    </div>
  );
};

Message.propTypes = {
  type: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string
  ]).isRequired
};

export default Message;
